import { Component, effect, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { RoutesEnum } from '../../../../enums/routes.enum';
import { UserRoleEnum } from '../../../../enums/user.enums';
import { AuthService } from '../../../../services/auth.service';
import { AuthStore } from '../../../../stores/auth.store';
import { UserStore } from '../../../../stores/user.store';
import { AlertComponent } from '../../../atoms/alert/alert.component';
import { AlertTypeEnum } from '../../../atoms/alert/alert.types';
import { InputComponent } from '../../../atoms/input/input.component';
import { PasswordInputComponent } from '../../../atoms/password-input/password-input.component';
import { AuthButtonComponent } from '../../../molecules/auth-button/auth-button.component';
import { AuthTemplateComponent } from '../../../organisms/auth-template/auth-template.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [
    AuthTemplateComponent,
    FormsModule,
    InputComponent,
    RouterLink,
    AuthButtonComponent,
    AlertComponent,
    PasswordInputComponent,
    PasswordInputComponent,
  ],
})
export class LoginComponent {
  protected RequestStateEnum = RequestStateEnum;
  protected AlertTypeEnum = AlertTypeEnum;

  public authService = inject(AuthService);
  public authStore = inject(AuthStore);
  public userStore = inject(UserStore);
  public router = inject(Router);

  public isLoading = false;
  public requestState = signal<RequestStateEnum | null>(null);
  public errorMsg = '';

  public form = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  private readonly redirectEffect = effect(() => {
    if (this.authStore.isLoggedIn() && this.authStore.userRole()) {
      this.redirect();
    }
  });

  public login(): void {
    const fc = this.form.controls;
    this.requestState.set(RequestStateEnum.PENDING);

    this.authStore
      .login(fc.email.value!, fc.password.value!)
      .pipe(
        catchError((err) => {
          console.log(err);
          this.requestState.set(RequestStateEnum.ERROR);
          if (err.status === 403) {
            this.errorMsg = 'User ist noch nicht verifiziert. Bitte prüfe deine Emails';
          } else {
            this.errorMsg = 'E-Mail oder Passwort stimmen nicht überein.';
          }

          return EMPTY;
        })
      )
      .subscribe(() => {
        this.requestState.set(RequestStateEnum.SUCCESS);
      });
  }

  private redirect(): void {
    if (this.authStore.userRole() === UserRoleEnum.COACH) {
      this.router.navigateByUrl(RoutesEnum.COACH_CHECK_IN);
    }
    if (this.authStore.userRole() === UserRoleEnum.USER) {
      this.router.navigateByUrl(RoutesEnum.USER_CHECK_IN);
    }
  }
}
